module.exports = __webpack_public_path__ + "img/nameabout.ca3f3a26.svg";